import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

function ListingDetailsPage() {
  const { id } = useParams(); // get listing ID from URL
  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchListing = async () => {
      try {
        const docRef = doc(db, 'listings', id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setListing(docSnap.data());
        } else {
          console.error('No such document!');
        }
      } catch (error) {
        console.error('Error fetching listing:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchListing();
  }, [id]);

  if (loading) return <div className="p-8 text-center">Loading...</div>;
  if (!listing) return <div className="p-8 text-center">Listing not found.</div>;

  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="grid md:grid-cols-2 gap-6">
        {/* Image Section */}
        <div className="flex flex-col items-center">
          <img
            src={listing.imageUrl}
            alt={listing.title}
            className="w-full max-h-[500px] object-contain rounded-lg border"
          />
        </div>

        {/* Info Section */}
        <div className="bg-white dark:bg-gray-900 shadow p-6 rounded-lg">
          <h1 className="text-3xl font-bold mb-4">{listing.title}</h1>
          <p className="text-2xl text-green-600 font-semibold mb-4">${listing.price}</p>

          <div className="space-y-2">
            {listing.description && (
              <div>
                <h2 className="font-semibold">Description:</h2>
                <p>{listing.description}</p>
              </div>
            )}
            <div><strong>Category:</strong> {listing.category}</div>
            <div><strong>Sex:</strong> {listing.sex}</div>
            <div><strong>Traits:</strong> {listing.traits}</div>
            <div><strong>Origin:</strong> {listing.origin}</div>
            <div><strong>Produced By:</strong> {listing.producedBy}</div>
            <div><strong>Birth Year:</strong> {listing.birth}</div>
            <div><strong>Weight (g):</strong> {listing.weight}</div>
            <div><strong>Proven:</strong> {listing.proven}</div>
            <div><strong>Diet:</strong> {listing.diet}</div>
            <div><strong>Shipping Info:</strong> {listing.shipping}</div>
            <div><strong>Payment Methods:</strong> {listing.payment}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListingDetailsPage;
